import React, { useEffect, useState, useContext } from "react";
import MenuBar from "./MenuBar";
import { logo } from "@utilities/api/util";
import { Link, useLocation } from "react-router-dom";
import {
  HeartSVG,
  ProfileSVG,
  SearchSVG,
  CartSVG,
  HamburgerMenuSVG,
} from "@icons";
import { useDispatch, useSelector } from "react-redux";
import {
  currentPage,
  setCompleted,
} from "../../../../redux/Slices/Products/productSearch";
import { HOME, CART, PRODUCTS, DEFAULTSHOPPINGLISTS } from "@constants/Routes";
import ProfileMenu from "../../UserAccount/ProfileMenu";
import MenuEmail from "../../UserAccount/MenuEmail";
import { userSelector } from "@slices/UserAccount/userSlice";

import {
  cartSelector,
  fetchcartItems,
  setDefaultScreen,
} from "@slices/cart/getTemporaryOrderData";
import { useGetLoggedInUserInfo } from "@hooks";
import { useForm } from "react-hook-form";
import {
  currentString,
  productsSelector,
} from "@slices/Products/productSearch";
import { WebSettingsContext } from "@providers/WebsettingsProvider";
import { useHistory } from "react-router-dom";
import { getCompareDetails } from "@slices/Products/productCompare";
import LoadingOverlay from "@common/LoadingOverlay";
import { useTranslation } from "react-i18next";
import { emptyItems } from "@slices/shoppingLists/shoppingListItemsReducer";
import { Dialog, DialogTitle, DialogContent, DialogContentText, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';

// Set up styles for top-right positioning
const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

const HeaderC = () => {
  const productState = useSelector(productsSelector);
  const webSettingsData: any = useContext(WebSettingsContext);
  const [searchText, setSearchText] = useState("");
  const { register, errors, handleSubmit } = useForm();
  const dispatch = useDispatch();
  const history = useHistory();
  const [loader, setLoader] = useState(false);
  const sessionId = useGetLoggedInUserInfo()?.sessionId;
  const { t, i18n } = useTranslation();
  const location = useLocation();

  const orderCounts = useSelector(cartSelector)?.cartItems?.lineCount;
  const userInfo = useSelector(userSelector)?.user?.user?.data;
  const onInputChange = (event: any) => {
    setSearchText(event.target.value);
  };

  function updateRefreshCount(): void {
    const countValue: string | null = sessionStorage.getItem('refreshCount');

    let count: number = (parseInt(countValue ?? '', 10) || 0) + 1;

    sessionStorage.setItem('refreshCount', String(count));

    console.log(`This page has been refreshed ${count} times in this session.`);
  }

  window.onload = () => {
    localStorage.removeItem('pageName');
  }
  window.onbeforeunload = () => {
    localStorage.removeItem('pageName');
  }
  useEffect(() => {
    // Your function to be called on URL change
    if(location.pathname.indexOf("/shoppingLists/listDetails") === -1 || location.pathname.indexOf("/catalog/MAIN_CAT/") === -1) {
      dispatch(emptyItems(null));
    }
  }, [location]);
  // useEffect(() => {
  //   if (productState.isCompleted) {
  //     setLoader(false);
  //   }
  // }, [productState.isCompleted]);

  /* for retaining pagination values */
  const params = new URLSearchParams(location.search);
  let paginationString = params.toString();
  if (paginationString !== null) {
    localStorage.setItem("paginationString", paginationString);
  }

  const handleCartRoute = () => {
    if (location?.pathname !== CART) {
      dispatch(
        setDefaultScreen({
          timeLine: {
            status: true,
            page: "cart",
          },
          addProduct: { status: false },
          interruptedCart: { status: false },
        })
      );
    }
  };

  const onSubmit = (event: any) => {
    localStorage.setItem('pageName', '');
    dispatch(currentPage(1));
    dispatch({
      type: currentString,
      payload: searchText,
    });

    dispatch(setCompleted(false));
    //setLoader(true);
    setSearchText("");
    dispatch({
      type: getCompareDetails,
      payload: [],
    });
  };

  useEffect(() => {
    i18n.changeLanguage(webSettingsData?.languageCode.toLocaleLowerCase());
  }, [webSettingsData?.languageCode]);

  useEffect(() => {
    if (sessionId) {
      dispatch(fetchcartItems(sessionId));
    }
  }, [sessionId]);

  const handleKeyPress = (target: any) => {
    // I'm guessing you have value stored in state
    if (target.charCode === 13) {
      history.push(`${PRODUCTS}`);
    }
  };
  const [showMenu, setShowMenu] = useState<boolean>(false);

  const menuHandler = () => {
    setShowMenu((prevState) => !prevState);
  };

  const classes = useStyles();

  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    if(sessionStorage.getItem('authenticatedUser') !== null) {
      updateRefreshCount();
    }

    if(sessionStorage.getItem('authenticatedUser') !== null && webSettingsData?.welcomeText && webSettingsData?.welcomeText.length > 0 && sessionStorage.getItem('refreshCount') && sessionStorage.getItem('refreshCount') === '1') {
      setOpen(true);
    }
  }, [webSettingsData]);

  return (
    <header className="header-sticky">
      <LoadingOverlay active={loader} />
      <section className="header-container border-bottom">
        <div className="row search-header align-items-center">
          <div className="hamburger-menu">
            {" "}
            <HamburgerMenuSVG
              onClick={menuHandler}
              className="secondary-icon-2"
            />
          </div>
          <div className="">
            <Link to={HOME} className="brand-wrap">
              <img style={{ marginTop: "3px" }} src={logo} alt="" />
            </Link>
          </div>
          <div className="mobile-block">
            <div className="widgets-wrap float-md-right">
              <div className="widget-header icontext">
                <Link
                  onClick={handleCartRoute}
                  to={sessionId ? CART : "#"}
                  className="icon icon-notification secondary-icon-2"
                >
                  <i>
                    <CartSVG />
                  </i>
                  <span className="badge badge-pill badge-danger notify">
                    {!orderCounts || !userInfo?.isAuthenticated
                      ? "0"
                      : orderCounts}
                  </span>
                </Link>
                <a href="#" className="icon icon-md secondary-icon-2">
                  <Link to={DEFAULTSHOPPINGLISTS}>
                    <i>
                      <HeartSVG style={{ marginTop: "-8px" }} />
                    </i>
                  </Link>
                </a>
                <div className="widget-header">
                  <ProfileMenu />
                </div>
              </div>
            </div>
          </div>
          <div style={{ display: "none" }}></div>
          <div className="search-area">
            <form onSubmit={handleSubmit(onSubmit)} className="search">
              <div className="input-group w-100">
                <input
                  type="text"
                  className="form-control search-bar"
                  placeholder="Search"
                  value={searchText}
                  onChange={(event) => onInputChange(event)}
                />
                <div
                  onClick={handleSubmit(onSubmit)}
                  className="input-group-append"
                >
                  <Link to={PRODUCTS}>
                    <button
                      style={{ margin: "0px" }}
                      className="btn btn-search"
                      type="submit"
                      onKeyPress={(e: any) => handleKeyPress(e)}
                    >
                      {/* onClick={handleSubmit(onSubmit)} */}
                      <i>
                        <SearchSVG className="secondary-icon-3" />
                      </i>
                    </button>
                  </Link>
                </div>
              </div>
            </form>
          </div>
          <div className=" mobile-hide">
            <div className="widgets-wrap float-md-right">
              <div className="widget-header  mr-3">
                <Link
                  onClick={handleCartRoute}
                  to={sessionId ? CART : "#"}
                  className="icon icon-notification secondary-icon-2"
                >
                  <i>
                    <CartSVG />
                  </i>
                </Link>
                <Link onClick={handleCartRoute} to={sessionId ? CART : "#"}>
                  <span className="badge badge-pill badge-danger notify ">
                    {!orderCounts ? "0" : orderCounts}
                  </span>
                </Link>
              </div>

              <div className="widget-header  mr-3">
                <a href="#" className="icon icon-sm secondary-icon-2">
                  <Link to={sessionId ? DEFAULTSHOPPINGLISTS : "#"}>
                    <i>
                      <HeartSVG />
                    </i>
                  </Link>
                </a>
              </div>
              <div className="widget-header  mr-3 ">
                <MenuEmail />
              </div>
              <div className="widget-header  mr-3">
                <ProfileMenu />
              </div>
            </div>
          </div>
        </div>

        <MenuBar menu={showMenu} onMenuChange={menuHandler} />
      </section>
      <Dialog className="welcome-dialog" open={open} onClose={handleClose}>
        <DialogTitle>
          <span className="dialog-title-text">{`${t("MSG_WELCOME")} ${webSettingsData?.userName}`}</span>
          <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div dangerouslySetInnerHTML={{ __html: `${webSettingsData?.welcomeText}` }} />
          </DialogContentText>
        </DialogContent>
      </Dialog>      
    </header>
  );
};

export default HeaderC;
